export default __webpack_public_path__ + "static/media/EggCryBabysvg.14d994fa.svg";